import img1 from '../images/box-item/card-item-3.jpg';
import img2 from '../images/box-item/card-item-4.jpg';
import img3 from '../images/box-item/card-item-2.jpg';
import img4 from '../images/box-item/card-item-7.jpg';
import img5 from '../images/box-item/card-item8.jpg';
import img6 from '../images/box-item/card-item-9.jpg';
import img7 from '../images/box-item/image-box-6.jpg';
import img8 from '../images/box-item/image-box-11.jpg';
import imgCollection1 from '../images/avatar/avt-18.jpg';

import img9 from '../images/box-item/image-box-project9.jpg';
import img10 from '../images/box-item/image-box-project-10.jpg';
import img11 from '../images/box-item/image-box-project-11.jpg';
import img12 from '../images/box-item/image-box-project-12.jpg';
import img13 from '../images/box-item/image-box-project-13.jpg';
import img14 from '../images/box-item/image-box-project-14.jpg';
import img15 from '../images/box-item/image-box-project-15.jpg';
import img16 from '../images/box-item/image-box-project-16.jpg';

const todayPickData = [
  {
    img: img2,
    title: 'FullstackDeveloper.shop',
    // tags: 'bsc',
    // imgAuthor: imga2,
    // nameAuthor: 'Trista Francis',
    // price: '4.89 ETH',
    // priceChange: '$12.246',
    // wishlist: '100',
    // feature: 'coming soon',
    imgCollection: imgCollection1,
    nameCollection: 'React',
  },
  {
    img: img7,
    title: 'MemoryBoard Flipcard Game ',
  },
  {
    img: img4,
    title: 'Handy-dandy Dev Blog',
  },
  {
    img: img11,
    title: 'React NFT OpeanSea.io Gallery',
  },
  {
    img: img6,
    title: 'ChrisDev Portfolio 2021',
  },
  {
    img: img3,
    title: 'Display Random UserApi -Typescript',
  },
  {
    img: img13,
    title: 'Rabbits Lawncare LandingPage',
  },
  {
    img: img1,
    title: 'Todo Rocket Planner 🚀 ',
    // imgAuthor: imga1,
  },
  {
    img: img9,
    title: 'Firebase & Google Auth Disney ',
  },
  {
    img: img10,
    title: 'Simon Says Color Game  -JQuery,DOM ',
  },
  {
    img: img5,
    title: 'React, Typescript Formik Form',
  },
  {
    img: img12,
    title: 'Vanilla JS & DOM Starbucks clone',
  },
  {
    img: img8,
    title: ' Youtube & IMDb Netflix API',
  },
  {
    img: img14,
    title: 'Reverse GeoLocation OpenWeather api ',
  },
  {
    img: img16,
    title: 'Node.js Chrisdev Blog',
  },
  {
    img: img15,
    title: 'Bootstrap Heroku Newsletter Signup Form',
  },
];

export default todayPickData;
